import type { Transportation } from 'model/NewMultipleBooking';
import type { Enrollment } from '@spike/membership-model';

export type EnrollmentAnchor = { dateKey: string; serviceId: number } | null;

export function resolveEnrollmentForSave(
    enrollment: Enrollment | undefined,
    anchor: EnrollmentAnchor,
    currentDateKey: string,
    currentServiceId: number | undefined
): Enrollment | undefined {
    if (enrollment == null || anchor == null) return undefined;
    if (currentServiceId == null || currentServiceId !== anchor.serviceId) return undefined;
    if (currentDateKey !== anchor.dateKey) return undefined;
    return enrollment;
}

export function transportationBookingDateKey(transportation: Transportation): string | undefined {
    const from = transportation.pickup?.time?.from ?? transportation.dropOff?.time?.from;
    return from?.isValid() ? from.clone().format('YYYY-MM-DD') : undefined;
}
